import { Injectable } from '@angular/core';
import { PaginatedModel } from "../../dominio/paginated-model";

@Injectable({
  providedIn: 'root'
})
export class PaginatorServiceV2 {
  private readonly defaultPageSizeOptions = [10, 30, 50];
  private readonly defaultPageSize = 10;

  constructor() { }

  getPageSize(): number {
    const itensPorPagina = localStorage.getItem('itensPorPagina') || this.defaultPageSize.toString();

    return parseInt(itensPorPagina, 10)
  }

  setPageSize(value: number | undefined | null): number {
    const pageSize = value || this.defaultPageSize;

    localStorage.setItem('itensPorPagina', pageSize.toString());
    return pageSize;
  }

  getPageSizeOptions(): number[] {
    return this.defaultPageSizeOptions;
  }

  createInstance(data: PaginatedModel | null = null): PaginatedModel {
    if (data) {
      data.pageSizeOptions = this.getPageSizeOptions();

      return data;
    }

    return {
      enabled: true,
      page: 1,
      pageSize: this.getPageSize(),
      pageSizeOptions: this.getPageSizeOptions(),
    };
  }
}
